(() => {
  const guide = document.getElementById('jpi-education-journey');

  if (!guide) return;

  /* The guide is embedded in Shopify's main content landmark. Give the
     nested element a distinct region role so assistive technology receives
     one main landmark and one clearly named guide region. */
  guide.setAttribute('role', 'region');
  guide.setAttribute('aria-labelledby', 'jpi-edu-title');
})();

